import { render, staticRenderFns } from "./IdentificationDateToInput.vue?vue&type=template&id=00aa5310&"
import script from "./IdentificationDateToInput.vue?vue&type=script&lang=js&"
export * from "./IdentificationDateToInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports